import BarItem from './barItem';

import './styles.css';

export default function Bars({ 
  bars,
  label,
  maxScore,
  isBigScores,
  alignBarTitle
}) {
  return (
    <ul className={`scores-bars ${isBigScores ? 'big-scores' : ''}`}> 
      {
        bars?.map((barItem, index) => (
          <BarItem
            key={index}
            title={barItem.title}
            score={barItem.score}
            lines={barItem.lines}
            color={barItem.color}
            formattedScore={barItem.score}
            maxScore={maxScore}
            label={label}
            alignBarTitle={alignBarTitle}
          />
        ))
      }
    </ul>
  );
};
